import React, { CSSProperties, FC, PropsWithChildren } from 'react';

const Scrollable: FC<PropsWithChildren<Pick<CSSProperties, 'maxHeight'>>> = ({
  children,
  maxHeight = '400px',
}) => {
  return (
    <div
      className="row"
      style={{ overflowY: 'auto', height: '100%', maxHeight: maxHeight }}
    >
      {children}
    </div>
  );
};

export default React.memo(Scrollable);
